<template>
    <div>
        <app-data-table
            :fields="fields"
            :items="data.data"
            @sort="onSort"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="description" slot-scope="{ item }">
                {{item.description | elipsis(80)}}
            </template>

            <template slot="approved_by_company_at" slot-scope="{ item }">
                <div v-if="item.approved_by_company_at"> {{item.approved_by_company_at | datetime }} </div>
                <div v-else> Sin aprobar </div>
            </template>

            <template slot="approved_by_client_at" slot-scope="{ item }">
                <div v-if="item.approved_by_client_at"> {{item.approved_by_client_at | datetime }} </div>
                <div v-else> Sin aprobar </div>
            </template>

            <template slot="answer_date" slot-scope="{ item }">
                {{item.answer_date | datetime}}
            </template>

            <template slot="petition_assignment.name" slot-scope="{ item }">
                <div v-if="item.petition_assignment.length" v-for="assignation in item.petition_assignment" :key="assignation.id">
                    {{!assignation.inactive?assignation.user.name:'' }}
                </div>
            </template>

            <template slot="resolution" slot-scope="{ item }">
                {{item.resolution | elipsis(80)}}
            </template>

            <template slot="files" slot-scope="{ item }">
                <div v-if="item.files.length" v-for="(file, i) in item.files">
                    <a :href="'/download/' + file.id" target="_blank">{{i+1}} - {{ file.name }}</a>
                </div>
            </template>

            <template slot="actions" slot-scope="{ item }">
                <b-button size="sm" variant="primary" title="Ver Comentarios" :disabled="!item.comments.length" @click="seeCommentsByPetition(item)"><i class="fa fa-comments"></i></b-button>
                <b-button variant="primary" size="sm" title="Ver PQR" @click="seeMore(item)"><i class="fa fa-search-plus" aria-hidden="true"></i></b-button> 
            </template>
        </app-data-table>
    </div>    
</template>
<script>
    export default {
        data() {
            return {
                fields: [
                    {
                        key: 'id',
                        label: 'ID'
                    },
                    {
                        key: 'petition_type.name',
                        label: 'Tipo'
                    },
                    {
                        key: 'client.name',
                        label: 'Cliente'
                    },
                    {
                        key: 'user.name',
                        label: 'Usuario creador'
                    },
                    {
                        key: 'description',
                        label: 'Descripción'
                    },
                    {
                        key: 'approved_by_company_at',
                        label: 'Fecha aprobación shatter'
                    },
                    {
                        key: 'approved_by_client_at',
                        label: 'Fecha aprobación cliente'
                    },
                    {
                        key: 'answer_date',
                        label: 'Fecha respuesta'
                    },
                    {
                        key: 'resolution',
                        label: 'Resolución'
                    },
                    
                    {
                        key: 'files',
                        label: 'Archivos',
                        sortable: false
                    },
                    {
                        key: 'actions',
                        label: 'Acciones'
                    }
                ]
            }
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            seeCommentsByPetition: {
                type: Function,
                required: true
            },
            seeMore: {
                type: Function,
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            }
        },
        methods: {
            onSort(ctx) {
                this.$emit('sort', ctx);
            }
        }
    }
</script>